// extracted by mini-css-extract-plugin
module.exports = {"main":"Main2_main__3V5nq","container":"Main2_container__14tV7","buttons":"Main2_buttons__1o-V9"};